export const TAB_VALUES = {
  OVERVIEW: 'overview',
  RISK_SCORE: 'risk-score',
  TRANSACTIONS: 'transactions',
  WATCHLIST: 'watchlist',
};
